import { IconNames } from '@shipengine/giger-theme';
import { useTranslation } from '@packlink/translation-provider';
import { Button, ButtonSize, ButtonVariant, Icon, IconSize } from '@shipengine/giger';
import { getDetailsButtonStyles, getDetailsButtonIconStyles } from './DetailsButtonStyles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { ServiceCardDialogType } from '../ServiceCardDialog/ServiceCardDialog.js';

const DetailsButton = _ref => {
  let {
    detailsNode,
    dialogOpen,
    fetchingDetails,
    onToggleDetails
  } = _ref;
  const {
    t
  } = useTranslation();
  return jsxs(Button, {
    size: ButtonSize.SMALL,
    onClick: onToggleDetails,
    variant: ButtonVariant.TEXT,
    css: getDetailsButtonStyles(!detailsNode && fetchingDetails),
    children: [t('service-card.details.see-details'), jsx(Icon, {
      size: IconSize.SIZE_SMALL,
      name: IconNames.CARET_BOTTOM,
      css: getDetailsButtonIconStyles(!!detailsNode && dialogOpen === ServiceCardDialogType.DETAILS)
    })]
  });
};

export { DetailsButton };
//# sourceMappingURL=DetailsButton.js.map
